/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StaffMemberRouteLinkItem from './StaffMemberRouteLinkItem';
import DemographicsIcon from 'icons/DemographicsIcon';

const messages = defineMessages({
  title: {id: 'navigation.demographics'},
});

const DemographicsItem = () => (
  <StaffMemberRouteLinkItem
    iconBefore={DemographicsIcon}
    route="midas/staff-member/demographics"
    title={messages.title}
  />
);

export default DemographicsItem;
